import React from 'react';
import './top-bar.css'

export interface TopBarProps extends React.HTMLProps<HTMLButtonElement & HTMLDivElement> {
  /**
   * Status that decides the color of the bar
   */
  barStatus?: 'green' | 'blue'

  /**
   * Message displayed to the user
   */
  text: string

  /**
   * Message displayed on the button of the dropdown
   */
  buttonText: string
};

export function TopBar({ barStatus = 'green', text, buttonText, onClick, ...otherProps }: TopBarProps) {

  return (
    <div className={`top-bar ${barStatus}`}>
      <label className='top-bar-label-text'>{text}</label>
      <button
        onClick={onClick || (() => { })}
        className={`top-bar-link`}>
        {buttonText}
      </button>
    </div>
  );
}